import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeEvery } from "redux-saga/effects";

import {
  getPendingInvitations,
  acceptInvitation,
} from "../../api/pendingInvitations";
import { applySagaError } from "../utils/saga";
import {
  fetchPendingInvitations,
  fetchPendingInvitationsSuccess,
  fetchPendingInvitationsFailure,
  setInvitationsLoading,
  acceptPendingInvitation,
  setAcceptingToken,
} from "./slice";
import { PendingInvitation } from "../../api/pendingInvitations";

function* fetchPendingInvitationsSaga() {
  try {
    yield put(setInvitationsLoading());

    const result: PendingInvitation[] | { error: string } = yield call(getPendingInvitations);

    if (Array.isArray(result)) {
      yield put(fetchPendingInvitationsSuccess(result));
    } else {
      yield put(fetchPendingInvitationsFailure(result.error));
    }
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "invitations.fetchPending",
      failureAction: fetchPendingInvitationsFailure,
    });
  }
}

function* acceptPendingInvitationSaga(action: PayloadAction<string>) {
  try {
    const token = action.payload;
    yield put(setAcceptingToken(token));

    const result: Awaited<ReturnType<typeof acceptInvitation>> = yield call(acceptInvitation, token);

    yield put(setAcceptingToken(null));

    if ("error" in result) {
      yield put(fetchPendingInvitationsFailure(result.error));
    } else {
      // Refetch the list after successful accept
      yield call(fetchPendingInvitationsSaga);
    }
  } catch (error) {
    yield put(setAcceptingToken(null));
    yield* applySagaError(error, {
      operationName: "invitations.accept",
      failureAction: fetchPendingInvitationsFailure,
    });
  }
}

export function* invitationsSaga() {
  yield takeEvery(fetchPendingInvitations.type, fetchPendingInvitationsSaga);
  yield takeEvery(acceptPendingInvitation.type, acceptPendingInvitationSaga);
}
